import { Component } from '@angular/core';
import { Student } from '../student.model';
import { StudentService } from '../student.service';
import { MatDialogRef } from '@angular/material/dialog';
import {SharedService} from '../../shared.service';
import {Router} from '@angular/router';

@Component({
    selector: 'app-student-in-focus',
    templateUrl: './student-in-focus.component.html'
})
export class StudentInFocusComponent {

    student: Student;

    constructor(
        private studentService: StudentService,
        private dialog: MatDialogRef<StudentInFocusComponent>,
        private sharedService: SharedService,
        private router: Router
    ) {
        this.student = this.studentService.selectedStudent;
    }

    clearFocus() {
        if (this.router.url.indexOf('/student360') > -1) {
            this.router.navigateByUrl('/classroom360/cards');
        }
        this.studentService.selectedStudent = undefined;
        this.studentService.updateSelectedStudent(undefined);
        this.closeClick();
    }

    closeClick() {
        this.dialog.close();
    }

}
